module.exports = __webpack_public_path__ + "static/media/Apple_Podcast_Icon-3.711b1f16.png";